<template>
  <v-container>
    <div class="sign-pg">
      <div class="sign-row">
        <div class="sign-form-top">
          <h2>{{ $t('Вход') }}</h2>
          <p>{{ $t('Введите E-mail') }}</p>
        </div>
        <form @submit.prevent="login">
          <div class="form-group">
            <input
              id="username"
              type="text"
              v-model.trim="username"
              class="form-control"
              :class="{
              invalid:
                ($v.username.$dirty && !$v.username.required) ||
                ($v.username.$dirty && !$v.username.email)
            }"
              placeholder="Email"
            />
            <small
              class="helper-text invalid"
              v-if="$v.username.$dirty && !$v.username.required"
            >
              {{ $t('Поле Email не должно быть пустым') }}
            </small>
            <small
              class="helper-text invalid"
              v-else-if="$v.username.$dirty && !$v.username.email"
            >
              {{ $t('Введите корректный Email') }}
            </small>
          </div>
          <div class="form-group password">
            <div style="position: relative;">
              <input
                id="password"
                :type="passwordFieldType"
                v-model.trim="password"
                class="form-control"
                :class="{
                invalid:
                  ($v.password.$dirty && !$v.password.required) ||
                  ($v.password.$dirty && !$v.password.minLength)
              }"
                :placeholder="$t('Пароль')"
              />
              <i
                :class="[
                showPassword ? 'pro-icon-eye-show' : 'pro-icon-eye-hide'
              ]"
                @click="showPassword = !showPassword"
              />
            </div>
            <small
              class="helper-text invalid"
              v-if="$v.password.$dirty && !$v.password.required"
            >
              {{ $t('Введите пароль') }}
            </small>
            <small
              class="helper-text invalid"
              v-else-if="$v.password.$dirty && !$v.password.minLength"
            >
              {{ $t('Пароль должен быть') }}
              {{ $v.password.$params.minLength.min }} {{ $t('символов') }}. {{ $t('Сейчас он') }}
              {{ password.length }}
            </small>
          </div>
          <div class="form-group">
            <button class="btn btn-default green" type="submit">{{ $t('Войти') }}</button>
          </div>
<!--          <div class="sign-form-bottom">-->
<!--            <div class="no-accaunt">-->
<!--              <p>{{ $t('Не зарегистрированы') }}?</p>-->
<!--              <router-link to="/register">{{ $t('Создайте аккаунт') }}</router-link>-->
<!--            </div>-->
<!--          </div>-->
        </form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { email, required, minLength } from 'vuelidate/lib/validators'
import messages from '@/utils/messages'
import { mapMutations } from 'vuex'

export default {
  name: 'Login',
  data: () => ({
    username: '',
    password: '',
    showPassword: false
  }),
  validations: {
    username: {
      email,
      required
    },
    password: {
      required,
      minLength: minLength(8)
    }
  },
  computed: {
    passwordFieldType () {
      return this.showPassword ? 'text' : 'password'
    }
  },
  mounted () {
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message])
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    async login () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.setLoading(true)

      const loginForm = {
        username: this.username,
        password: this.password
      }

      try {
        await this.$store.dispatch('login', loginForm)
        await this.$router.push('/my-organization')
        // Редирект на предыдущую страницу (отключен временно)
        // const redirect = sessionStorage.getItem('redirectPath')
        // redirect ? await this.$router.push(redirect) : await this.$router.go(-1)
        // Cleanup redirectPath
        // sessionStorage.removeItem('redirectPath')
        this.setLoading(false)
      } catch (error) {
        this.setLoading(false)
      }
    }
  }
}
</script>
